'use strict'

readLdJSON = (domID) ->
  el = document.getElementById(domID)
  return {} if not el

  text = (el.textContent).trim()
  try
    JSON.parse text
  catch error
    error.message += 'Attempted to parse:' + text
    throw error

module.exports = {
  readLdJSON
}
